<template>
  <div>
    <div id="articulos">
      <div class="d-flex inputs">
        <div class="form-group text-left col-lg-5">
          <label for="categoria">Seleccionar una categoría</label>
          <select v-model="cat_id" class="form-control" id="slcCategoria">
            <option :value="null" >Todas</option>
            <option v-for="cat in categorias" :value="cat.id" :key="cat.value">{{cat.nombre}}</option>
          </select>
        </div>
        <div class="form-group text-left col-lg-5">
          <label for="categoria">Filtrar por título</label>
          <input type="search" class="form-control" placeholder="Buscar por Titulo" id="schArticle" @input="findByTitle()" @keyup.delete="findByTitle()"/>
        </div>
      </div>
      <div id="hidden-message" style="display:none;">
        <PostNotFound/>  
      </div>
      <VueSlickCarousel v-if="articulos.length >0" v-bind="settings" ref="postSlider" >
        <div v-for="articulo in articulos" :value="articulo.value" :key="articulo.value" class="col-lg-12 article">
          <div>
            <i v-if="articulo.fijo" class="fa fa-star float ml-4" style="position:absolute;"></i>
            <img :src="url + articulo.imagen" style="position:absolute;">
            <p>{{articulo.titulo}}</p>
            
            <div class="col-lg-12">
              <b-link v-if="articulo.activo" :title="'Desactivar '+ articulo.titulo" class="mr-2 btnDesactivate" @click="deletePost(articulo)"></b-link>
              <b-link v-else :title="'Activar '+ articulo.titulo" class="mr-2 btnActivate" @click="activatePost(articulo)"></b-link>
              <b-link :title="'Editar '+ articulo.titulo" class="mr-2 btnEdit" @click="editPost(articulo)"></b-link>
              <b-link :to="'/blog/articulo/' +  articulo.id" class="float-right">Ver <b-icon icon="chevron-right" class="ml-2 chevron"></b-icon></b-link>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>

import env from '@/plugins/enviroment';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import PostNotFound from '@/components/post-not-found-manager.vue';
import postsApi from "../api/posts";
import categoriasApi from "../api/categorias";
import {mapState,mapActions} from "vuex"; 
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";

// optional style for arrows & dots

export default {
  data() {
    return {
      articulos:[],
      categorias:[],
      cat_id:null,
      titulo_art:"",
      urlImg:"",
      settings:{
  "dots": true,
  "arrows":true,
  "infinite": false,
  "speed": 500,
  "slidesToShow": 4,
  "slidesToScroll": 4,
  "responsive": [
    {
      "breakpoint": 1024,
      "settings": {
        "slidesToShow": 3,
        "slidesToScroll": 3,
        "infinite": false,
        "dots": true
      }
    },
    {
      "breakpoint": 480,
      "settings": {
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "infinite":false,
        "dots":false
      }
    }
  ]
}
    }
  },
  components: {
    PostNotFound,
    VueSlickCarousel
  },
  computed: {
    ...mapState("posts",["id",
                         "categoria_id",
                         "titulo",
                         "introduccion",
                         "descripcion",
                         "imagen",
                         "tipo",
                         "fecha_publicacion",
                         "activo"]),
  },
  watch: {
    cat_id(newValue, oldValue) {
      this.getPosts();
    },
    titulo_art(newValue, oldValue) {
      this.getPosts();
    }
  },
  methods: {
    ...mapActions("posts",['setPost']),
    isMobile() {
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    findByTitle(e){
      var title = document.getElementById("schArticle").value;

      if(title.length > 2){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.titulo_art = title;
          //clearTimeout(this.timeout);
        },1000);
         
      }else{
        clearTimeout(this.timeout);
        this.titulo_art = "";
      }
      
      
     
    },
     getCategorias(){
      /*
      -PARAMETROS PERMITIDOS-
        nombre=conta
        activo=true
        paginate=true
        items_to_show=10
        order=asc
        order_by=id
        -------------------------*/

      let parametros = {paginate:false,items_to_show:10,activo:true,order:"asc",order_by:"id"};
      categoriasApi
      .getCategorias(parametros)
      .then(response => {
        this.categorias = response.data.data;
      }).catch(err => {
        console.log("Ocurrio un error al cargar las categorías.");
      });
    },
    getPosts(){
      /*
      -PARAMETROS PERMITIDOS-
        categoria_id=1
        titulo=conta
        tipo=posts
        fecha_publicacion=2020-10-02
        min_fecha_publicacion=2020-10-02
        max_fecha_publicacion=2020-10-03
        activo=true
        paginate=true
        items_to_show=10
        order=asc
        order_by=fecha_publicacion
        -------------------------*/

      let parametros = {categoria_id:this.cat_id,titulo:this.titulo_art,paginate:false,items_to_show:10,order:"asc",order_by:"id"};
      postsApi
      .getPosts(parametros)
      .then(response => {

        this.articulos = response.data.data;
        
        var message = document.getElementById("hidden-message");
       
        if(this.articulos.length == 0){
          message.style.display="inline";
        }else{
          message.style.display="none";
        }
        
      }).catch(err => {
        console.log("Ocurrio un error al cargar los articulos.");
      });
    },
    editPost(post){
      this.setPost(post)
    },
    activatePost(post){
      /*-PARAMETROS PERMITIDOS-
        categoria_id=1
        titulo=conta
        tipo=posts
        fecha_publicacion=2020-10-02
        min_fecha_publicacion=2020-10-02
        max_fecha_publicacion=2020-10-03
        activo=true
        paginate=true
        items_to_show=10
        order=asc
        order_by=fecha_publicacion
        -------------------------*/

      let parametros = {id:post.id,categoria_id:post.categoria_id,titulo:post.titulo,introduccion:post.introduccion,tipo:post.tipo,activo:true};

      postsApi
      .updatePost(parametros)
      .then(response =>{
        Notify.SuccessToast("Listo, el Artículo: "+post.titulo+", es visible al publico");
        this.getPosts();
      }).catch(err => {
        Notify.ErrorToast("Lo sentimos: Ocurrió un error - No pudimos activar el artículo.");
      });
      
    },
    deletePost(post){
      let self = this;
      Notify.Confirm("Espere", "¿Está seguro de deshabilitar el Artículo: "+post.titulo+"?, Sólo se desactivara y ya no será visible para los visitantes del sitio.", "Aceptar", "Cancelar",
      function OnSucces(){
        postsApi
        .deletePost(post.id)
        .then(response => {
            Notify.Success("¡Listo!","Artículo: "+post.titulo+" ha sido eliminado correctamente, podrás reactivarlo desde el panel.",null,
            function ok(){
              self.getPosts();
            });
          }).catch(err => {
            Notify.ErrorToast("Lo sentimos: Ocurrió un error - El artículo no se eliminó.");
          });
        });
    }
  },mounted () {
      
    },
  created () {
    this.url = env.baseURL;
    this.getCategorias();
    this.getPosts();
  },
}
</script>

<style scoped> 
  .form-group > label{
    font-family: Muli;
    font-style: normal;
    font-weight: 300;
    font-size: 19.6154px;
    line-height: 33px;
    display: flex;
    align-items: center;
    color: #1E2144;
  }
  .inputs{
    margin-top:-88px;
    margin-bottom:90px;
  }
  
  .btnDesactivate{
    content: url("/static/images/icons/visible.svg");
  }

  .btnActivate{
    content: url("/static/images/icons/no-visible.svg");
  }
  
  .btnEdit{
    content: url("/static/images/icons/edit.svg");
  }

  .article:hover .btnDesactivate{
    content: url("/static/images/icons/no-visible.svg");
  }

  .article:hover .btnActivate{
    content: url("/static/images/icons/visible.svg");
  }

  .article:hover .btnEdit{
    content: url("/static/images/icons/edit-activate.svg");
  }
  input[type=search]{
  padding:22px !important;
  border-radius: 10px !important;
}
  .article{
    margin-bottom:auto;
    text-align: left;
  }
.article > div{
    margin:0px 0px 10px 0px;
    padding-bottom:15px;
    transition: 0.3s;
  }
  .article:hover > div{
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  }
  .article img {
    width: 100%;
    height: 29vh;
    border-radius: 10px;
  }

  .article p {
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
    color: #1E2245;
    padding:15px;
    height: 140px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 10px;
  }

  .article a{
    padding-left:15px ;
    margin-bottom:10px;
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #1E2245;
  }

  @media(max-width: 768px){
  .article img {
    height: 35vh;
  }

    
  }

</style>
